window.ttx = window.ttx || {};
ttx.extend = {};

ttx.extend.registerExtBillScripts = (extBillScripts = [], type) => {
    if (ttx.utils.isArray(extBillScripts)) {
        if (type == 'ynf') {
            if (!window.__EXT_BILL_SCRIPTS_YNF__) window.__EXT_BILL_SCRIPTS_YNF__ = []
            window.__EXT_BILL_SCRIPTS_YNF__ = window.__EXT_BILL_SCRIPTS_YNF__.concat(extBillScripts)
        } else {
            if (!window.__EXT_BILL_SCRIPTS__) window.__EXT_BILL_SCRIPTS__ = []
            window.__EXT_BILL_SCRIPTS__ = window.__EXT_BILL_SCRIPTS__.concat(extBillScripts)
        }
    }
}

ttx.extend.transferFormMode = function (mode) {
    let state = -1;
    switch (mode) {
        case 'add':
            state = 1;
            break;
        case 'edit':
            state = 1;
            break;
        case 'browse':
            state = 2;
            break;

        default:
            break;
    }
    return state;
};

// 扩展   用于对params做一下处理
ttx.extend.processParams = function (params, callback) {
    return new Promise(async (resolve, reject) => {
        try {
            // 1. 深拷贝参数
            const _params = ttx.utils.extend(true, {}, params);

            // 2. 处理 menuUrl 自动解析 query
            if (_params?.menuUrl && !_params.query) {
                const queryString = new ttx.utils.queryString(_params.menuUrl);
                _params.query = queryString.query;
            }

            // 3. 处理 metaid（异步逻辑，必须等待完成）
            if (_params?.query && !_params.query.metaid) {
                const { appCode, serviceCode } = _params.query;

                // appCode/serviceCode 都为空时跳过，避免无意义请求报错（如卡片页新增场景）
                if (appCode && serviceCode) {
                    // 等待异步接口执行完成
                    const result = await new Promise((res) => {
                        ttx.extend.getMetaByServiceCode(appCode, serviceCode, res);
                    });

                    // 赋值 metaid
                    if (result?.data?.id) {
                        _params.query.metaid = result.data.id;
                    }
                }
            }

            // 4. 所有逻辑处理完，再回调 &  resolve
            if (typeof callback === 'function') {
                callback(_params);
            }
            resolve(_params);

        } catch (err) {
            // 统一异常处理
            ttx.console.error(null, 'processParams 处理失败：', err);
            if (typeof callback === 'function') {
                callback(_params);
            }
            reject(err);
        }
    })
}
/** 从页面参数拼接完整链接（兼容 portal 'none' 模式下 window.location 无路径的情况） */
ttx.extend.getPageUrl = function (ctx) {
    // 优先从浏览器地址栏获取（钻取后路径已更新为 /meta/card/billno/billid）
    var locPath = window.location.pathname;
    var locSearch = window.location.search;
    var matchCard = locPath.match(/^\/meta\/card\/([^/]+)\/(\d+)/);
    if (matchCard) {
        return window.location.origin + locPath + locSearch;
    }

    // 回退：用 portal 参数拼 URL（portal 'none' 模式用 __portalCurrentParams）
    var portalParams = window.__portalCurrentParams || {};
    var billtype = portalParams.billtype || '';
    var billno = portalParams.billno || '';
    var query = portalParams.params?.query || {};

    // VM：优先 ctx.vm，其次按 key 精准取
    var vm = ctx?.vm || (ctx?.key ? ttx.debug?.getVM?.(ctx.key) : ttx.debug?.getCurrentVM?.());

    // 通过 key 拿不到 VM 但 portalParams 已是 card 类型（Pane addItem 拦截器已同步更新），
    // 回退到 getCurrentVM 获取卡片 VM
    if (!vm && portalParams.billtype === 'card') {
        vm = ttx.debug?.getCurrentVM?.();
    }

    // 如果 key 对应的 VM 是列表页（无 billid），但 portalParams 已是 card 类型且当前活跃 VM 有 billid（钻取到卡片），则用活跃 VM
    if (vm && portalParams.billtype === 'card' && !vm._get_data?.('id') && !vm.getCache?.('id') && !(vm.getData?.() || {}).id) {
        var curVm = ttx.debug?.getCurrentVM?.();
        if (curVm && curVm !== vm) {
            var curData = curVm.getData?.() || {};
            if (curData.id || curVm._get_data?.('id') || curVm.getCache?.('id')) {
                vm = curVm;
            }
        }
    }

    if (vm) {
        // 从 VM 取 billno
        var vmParams = vm.getParams?.() || {};
        billno = vmParams.billno || vmParams.billNo || billno;

        // 从 VM 多个可能位置取 billid
        var vmData = vm.getData?.() || {};
        var billid = vmData.id
            || vm._get_data?.('id')
            || (vm._get_data?.('value') || {}).id
            || vm.getCache?.('id')
            || vmParams.id
            || (vmParams.params || {}).id
            || '';

        if (billid) {
            billtype = 'card';
        }

        // 从 VM 取 query（含 metaid / appCode / serviceCode）
        var vmQuery = vmParams.query || (vmParams.params || {}).query || {};
        // metaid：优先 VM 的 query.metaid，其次 VM data/cache 里的 metaid
        query.metaid = query.metaid || vmQuery.metaid
            || vm._get_data?.('metaid') || vm.getCache?.('metaid') || '';
        // appCode / serviceCode：优先保留 __portalCurrentParams 已有的，其次从 VM query 补
        if (!query.appCode) query.appCode = vmQuery.appCode || '';
        if (!query.serviceCode) query.serviceCode = vmQuery.serviceCode || '';
        // mode：add / edit / browse，从 VM params 获取（不在 query 子对象内，在 params.mode）
        if (!query.mode) query.mode = vmParams.mode || (vmParams.params || {}).mode || '';
        // lang：语言，默认 zh
        if (!query.lang) query.lang = vmQuery.lang || 'zh';

        // ============================================================
        // query 参数链路（所有 query 参数原样保留，不做过滤）：
        //
        // 来源1：菜单点击 → menu.js → Transfer.openService()
        //   params.query = { appCode, serviceCode }  → __portalCurrentParams
        //
        // 来源2：钻取/联查 jointQuery → runCommandLine('bill', { params: { mode, query: {...} } })
        //   params = { mode:'browse', query: { metaid, id } }
        //   → VM.getParams().mode = 'browse', VM.getParams().query = { metaid, id }
        //                            ↑ id 用于打开详情页，必须保留
        //
        // 来源3：add 命令 → runCommandLine('bill', { params: { mode:'add', query:{...} } })
        //   params = { mode:'add', query: { metaid, ... } }
        //
        // 合并策略：__portalCurrentParams.query 为基础（appCode/serviceCode），
        //          VM query 补 metaid/id 等字段，mode 从 VM params.mode 取，优先保留已有值
        //
        // 已支持的 query 参数：appCode, serviceCode, metaid, id, mode, lang（默认 zh）
        // 未来新增参数（如 lang 等）无须修改此处，自动透传
        // ============================================================
        var keys = Object.keys(query).filter(function (k) { return query[k] !== '' && query[k] != null; });
        var search = keys.length ? '?' + keys.map(function (k) {
            return encodeURIComponent(k) + '=' + encodeURIComponent(query[k]);
        }).join('&') : '';
        var path = '/meta/' + billtype + '/' + billno + (billid ? '/' + billid : '') + search;
        return window.location.origin + path;
    }

    // 无 VM 时的兜底：用 portalParams 里的 billid 和 mode
    // query 参数同上，原样保留，不做过滤
    var billid = portalParams.billid || '';
    if (billid) billtype = 'card';
    if (!query.mode) query.mode = (portalParams.params || {}).mode || '';
    if (!query.lang) query.lang = ((portalParams.params || {}).query || {}).lang || 'zh';
    var keys = Object.keys(query).filter(function (k) { return query[k] !== '' && query[k] != null; });
    var search = keys.length ? '?' + keys.map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(query[k]);
    }).join('&') : '';
    var path = '/meta/' + billtype + '/' + billno + (billid ? '/' + billid : '') + search;
    return window.location.origin + path;
};

// 扩展  用于页面路径上没有?metaid=xxx时 主动根据servieCode获取meta
ttx.extend.getMetaByServiceCode = function (appCode, serviceCode, callback) {
    // 根据serviceCode获取meta
    ttx.ajax.xhrUtil({
        url: '/api/meta/getMetas',
        method: 'get',
        data: {
            type: 1, // 列表
            appCode: appCode,
            serviceCode: serviceCode
        },
        success: (res) => {
            callback(res);
        }
    })
}

// ===== merged from tx.extend2.js =====
let ahProxyInstance;

const ahProxyHandler = function (billno) {
  return function (options, carving) {
    const identity = ttx.rest._ah?.flag?.getIdentity?.();
    if (!identity) {
      ttx.console.log('[ahProxyHandler]: ivalid tenantID or invalid userID!');
    }
    if (carving)
      carving.isProxy = ttx.rest.billIsOffline && billno && identity && ttx.rest._ah?.runtimeCachedMap[identity]?.[billno];
    else
      return ttx.rest.billIsOffline && billno && ttx.rest._ah?.runtimeCachedMap[identity]?.[billno];
  }
}
const handleProxyInstance = function (billno) {
  ahProxyInstance && ttx.rest._ah.un('ah_proxy_intercept', ahProxyInstance);
  ttx.rest._ah.on('ah_proxy_intercept', ttx.rest._ah.currentBillIsOffline = ahProxyInstance = ahProxyHandler(billno));
}

const unProxyInstance = function () {
  ahProxyInstance && ttx.rest._ah.un('ah_proxy_intercept', ahProxyInstance);
  ttx.rest._ah.currentBillIsOffline = null;
  ahProxyInstance = null;
}

if (!window.__MDF_SPEED_MODE__) {
  window.$PORTAL_EVENT?.$on('messagecenter_publish_webUrl', (res) => {
    const urls = ttx.utils.jsonParse(res);
    if (!ttx.utils.isEmptyObject(urls)) {
      const domainKeys = [];
      const serviceCodeMap = {};
      urls.forEach(element => {
        if (element.indexOf('/meta/voucher/') > 0) {
          try {
            const url = new URL(element);
            const domainKey = url.searchParams.get('domainKey');
            const serviceCode = url.searchParams.get('serviceCode');
            if (!domainKeys.includes(domainKey)) {
              domainKeys.push(domainKey);
            }
            if (!serviceCodeMap[domainKey]) {
              serviceCodeMap[domainKey] = serviceCode;
            }
          } catch (err) {
            // @ts-ignore
            ttx.console.error(Error.E01000, '[cube][window.$PORTAL_EVENT?.$on]: messagecenter_publish_webUrl:', err)
          }
        }
      });
      if (!ttx.utils.isEmptyObject(domainKeys)) {
        const reqList = [];
        domainKeys.forEach(domain => {
          reqList.push(getLoginUser(domain, null, serviceCodeMap[domain] || null));
          reqList.push(loadExtend(domain, null));
        });
        Promise.all(reqList).then(result => {}).catch(err => {
          // @ts-ignore
          ttx.console.error(Error.E01000, '[cube][window.$PORTAL_EVENT?.$on]: loadExtend:', err.message || err)
        });
      }
    }
  })
}

const setDomainConfigs = function (domainConfigs) {
  for (const domainKey in domainConfigs) {
    if (Object.prototype.hasOwnProperty.call(domainConfigs, domainKey)) {
      const config = domainConfigs[domainKey];
      ttx.utils.setDomainEnv(domainKey, config.env);
      ttx.utils.setDomainFeatures(domainKey, config.features);
      ttx.cache.domains.set(domainKey, config.serviceDomain)
      ttx.cache.appServers.set(domainKey, config.appServer || ('/' + domainKey));
    }
  }
}

// 存储已经加载的domainKey
const cacheExtendUrls = {};
const getExtendUrl = async function (domainKey, panelLoadingArgs, params) {
  panelLoadingArgs = panelLoadingArgs || {}
  const isUpesnApplet = window.__isUpesnApplet === 'upesn-applet';
  let netWorkStatus = true
  if (isUpesnApplet && !ttx?.utils?.getUrlParams?.()?.debug) netWorkStatus = await ttx.mtl.getNetworkType();
  return new Promise(function (resolve) {
    if (isUpesnApplet && !netWorkStatus) {
      if (params) {
        params = {}
      }
      const cacheExtendUrls = localStorage.getItem('cacheExtendUrls') || '{}';
      try {
        const parseUrls = JSON.parse(cacheExtendUrls)[domainKey];
        if (parseUrls?.extendUrls) {
          if (parseUrls.domainConfigs) setDomainConfigs((parseUrls.domainConfigs));
          resolve(parseUrls.extendUrls);
          return;
        }
      } catch (err) {
        ttx.console.log(`[getExtendUrl]: localStorage获取cacheExtendUrls失败，cacheExtendUrls is ${cacheExtendUrls}, domainKey is ${domainKey}`, err);
      }
    } else {
      if (cacheExtendUrls[domainKey] && cacheExtendUrls[domainKey].extendUrls) {
        if (cacheExtendUrls[domainKey].domainConfigs) setDomainConfigs((cacheExtendUrls[domainKey].domainConfigs));
        resolve(cacheExtendUrls[domainKey].extendUrls);
        return;
      }
    }
    let requestUrl = `/mdf/resource/loadExtend?domainKey=${domainKey}`;
    if (window.name === '_WORKBENCH_' && ttx.rest.interMode !== 'mobile') {
      requestUrl = `/mdf/resource/loadExtend?domainKey=${domainKey}&isMobile=false`
    }
    if (ttx.utils.isFileProtocol() && params?.resource !== 'remote') {
      requestUrl = '/mdf/resource/loadExtend?protocol=file'
    }
    // 设计器模式下需要加载扩展组件脚本添加参数即可
    if (ttx.__DIWORK_INTEGRATION_MODE__ === 'design') {
      // PC的需要加载设计器版本资源，低代码除外
      if (ttx.rest?.interMode === 'web' && domainKey !== 'developplatform') {
        requestUrl += '&isDesigner=true'
      }
      // 移动端在低代码扩展加载应为移动版本
      if (ttx.rest?.interMode === 'mobile') {
        requestUrl += '&isMobile=true'
      }
    }
    const proxy = ttx.rest.DynamicProxy.create({
      loadExtend: {
        url: requestUrl,
        method: 'GET',
        options: { uniform: false, domainKey, terminalType: false, ...panelLoadingArgs }
      }
    })
    if (typeof params?.beforeLoadExtend === 'function') {
      params.beforeLoadExtend({requestConfig: proxy.config.loadExtend})
    }
    proxy.loadExtend(function (err, result) {
      if (err) {
        // @ts-ignore
        ttx.console.error(Error.E01000, '[cube][getExtendUrl]:', err.message || err)
      }
      let extendUrls = [];
      if (result.scriptUrls) extendUrls = extendUrls.concat(result.scriptUrls);
      if (result.styleUrls) extendUrls = extendUrls.concat(result.styleUrls);
      if (result.baseUrls) ttx.cache.baseUrls.setAll(result.baseUrls);
      if (result.versionJSON) ttx.cache.versionJSON.setAll(result.versionJSON); // versionJSON: {${domainKey}: version.json内容} 缓存维度是domainKey，和baseUrls一致
      if (result.domainConfigs) {
        setDomainConfigs(result.domainConfigs)
      }
      if (extendUrls) {
        if (isUpesnApplet) {
          try {
            const cacheExtendUrls = localStorage.getItem('cacheExtendUrls') || '{}';
            const cacheLocalUrls = JSON.parse(cacheExtendUrls);
            if (!cacheLocalUrls[domainKey]) cacheLocalUrls[domainKey] = {}
            cacheLocalUrls[domainKey].extendUrls = extendUrls;
            if (result.domainConfigs) cacheLocalUrls[domainKey].domainConfigs = result.domainConfigs;
            localStorage.setItem('cacheExtendUrls', JSON.stringify(cacheLocalUrls));
          } catch (err) {
            ttx.console.log(`[getExtendUrl]: localStorage获取cacheExtendUrls失败，cacheExtendUrls is ${cacheExtendUrls}, domainKey is ${domainKey}`, err);
          }
        } else {
          if (!cacheExtendUrls[domainKey]) cacheExtendUrls[domainKey] = {}
          cacheExtendUrls[domainKey].extendUrls = extendUrls;
          if (result.domainConfigs) cacheExtendUrls[domainKey].domainConfigs = result.domainConfigs;
        }
      }
      if (result.errorMessage) {
        ttx.console.error(Error.E00001, result.errorMessage)
      }
      resolve(extendUrls);
    });
  })
}

const loadExtend = async function (domainKey, panelLoadingArgs, params) {
  const needLoad = await preLoadExtend(domainKey, panelLoadingArgs, params);
  if (!needLoad) return;
  const urls = await getExtendUrl(domainKey, panelLoadingArgs, params);
  if (!params) params = {};
  params.urls = urls;
  await loadExtendUrl(domainKey, panelLoadingArgs, params);
}

const preLoadExtend = async function (domainKey, panelLoadingArgs, params) {
  if (ttx.utils.isFileProtocol() && !ttx.cache.get('loadExtendError')) ttx.cache.set('loadExtendError', {});
  if (domainKey === 'retail' && ttx.utils.isUretailIndependentApp && ttx.utils.isUretailIndependentApp()) {
    await getExtendUrl(domainKey, panelLoadingArgs, params);
    return false;
  }
  if (ttx.extend.Scripts && ttx.extend.Scripts[domainKey]) {
    return false;
  }
  return true;
}

const loadExtendUrl = async function (domainKey, panelLoadingArgs, params) {
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  return new Promise(async (resolve) => { // eslint-disable-line no-async-promise-executor
    ttx.utils.loadingControl.start({ ...panelLoadingArgs, caller: 'extend.min.js' });
    if (ttx.events.hasEvent(domainKey + 'loadExtendReady')) {
      ttx.utils.loadingControl.end({ ...panelLoadingArgs, caller: 'extend.min.js' });
    }
    ttx.events.on(domainKey + 'loadExtendReady', async function (arg) {
      const domainKey = arg.domainKey;
      ttx.utils.loadingControl.end({ ...panelLoadingArgs, caller: 'extend.min.js' });
      if (panelLoadingArgs?.loadLang !== false) {
        await getLangTemplate(domainKey, panelLoadingArgs)
      }
      resolve(true)
    })
    const requireInnerCallback = async () => {
      if (ttx.extend[domainKey + 'registerExtend'] == true) return;
      ttx.utils.loadingControl.end({ ...panelLoadingArgs, caller: 'extend.min.js' });
      if (panelLoadingArgs?.loadLang !== false) {
        await getLangTemplate(domainKey, panelLoadingArgs)
      }
      resolve(true);
    }
    // 加载扩展资源
    if (ttx.context.getQuery().extend == 'false') {
      return requireInnerCallback();
    }
    try {
      const urls = params?.urls;
      ttx.requireInner(urls, async function () {
        await requireInnerCallback();
      }, async function () {
        ttx.console.log(`[ttx.requireInner]: urls required error, urls: ${urls.join(',')}`);
        // 小程序部分资源加载不到 从cdn重新加载一次
        if (ttx.utils.isFileProtocol()) {
          const loadExtendError = ttx.cache.get('loadExtendError')
          if (!loadExtendError[domainKey]) {
            loadExtendError[domainKey] = true
            await loadExtend(domainKey, panelLoadingArgs, { resource: 'remote' })
            return;
          }
        }
        if (ttx.extend[domainKey + 'registerExtend'] == true) return;
        ttx.utils.loadingControl.end({ ...panelLoadingArgs, caller: 'extend.min.js' });
        await getLangTemplate(domainKey, panelLoadingArgs)
        resolve(false);
      }, undefined, { waitSeconds: window.__MDF_EXTEND_WAIT_SECONDS__ || 60, name: 'extendScript' }) // 加载extend.min.js时，最多等待60s
    } catch (err) {
      resolve(false);
      ttx.console.error(err)
    }
  })
}

const getLoginUser = async function (domainKey, panelLoadingArgs, serviceCode) {
  return new Promise(function (resolve) {
    if (ttx.rest.AppContext[domainKey]) {
      resolve(true);
      return;
    }
    if (!ttx.extend.hasFeature(domainKey, 'queryLoginUser')) {
      resolve(true);
      return;
    }
    let url = 'user/getLoginUser';
    if (serviceCode) {
      url = ttx.rest._appendUrl(url, { serviceCode: serviceCode })
    }
    const proxy = ttx.rest.DynamicProxy.create({ getLoginUser: { url: url, method: 'GET', options: { uniform: false, domainKey, ...panelLoadingArgs } } })
    const successFunc = (result) => {
      ttx.rest.AppContext[domainKey] = result ? { user: result, tenant: result.tenant, option: result.option, query: {} } : {};
      resolve(true);
    }
    const failFunc = (err) => {
      // @ts-ignore
      ttx.console.error(Error.E01000, `[cube][getLoginUser(domainKey=${domainKey})]:`, err.message || err)
    }
    // 开启特性开关cacheLoginUser则先从indexDB取值
    const openFeature = ttx.extend.hasFeature(domainKey, 'cacheLoginUser')
    ttx.rest.executeProxy(
      {
        domainKey,
        openFeature,
        proxy,
        proxyName: 'getLoginUser',
        successFunc,
        failFunc
      }
    )
  })
}

const isvAuthByCode = async function (domainKey, isvCode, panelLoadingArgs) {
  return new Promise(function (resolve) {
    if (!isvCode) {
      resolve(true);
      return;
    }
    if (ttx.extend.hasFeature(domainKey, 'isvAuthByCode')) {
      const proxy = ttx.rest.DynamicProxy.create({
        isvAuthByCode: {
          url: '/uniformdata/rest/v1/abpaas/isv/auth/code?code=' + isvCode,
          method: 'GET',
          options: { uniform: false, domainKey, terminalType: false, ...panelLoadingArgs }
        }
      })
      proxy.isvAuthByCode(function (err, result) {
        if (err) {
          // @ts-ignore
          ttx.console.error(Error.E01000, 'cube[isvAuthByCode]:', err.message || err)
        }
        resolve(result);
      });
    } else {
      resolve(true);
    }
  })
}

const getLangTemplate = async function (domainKey, panelLoadingArgs) {
  return new Promise((resolve) => {
    const multilingualFlag = ttx.context.global.isMultilingualFlag()
    if (!ttx.lang || !ttx.lang.extendsRender || multilingualFlag === false) {
      resolve(true);
      return;
    }
    ttx.lang.extendsRender(domainKey, null, resolve, { ...panelLoadingArgs, caller: 'getLangTemplate' })
  })
}
const preLoadByBillNo = (viewmodel, data) => {
  if (ttx.rest._ah && data.params?.query?.skipOffline !== 'true') { // feat:DGYLGG-12447 临时兼容资产同一billNo多单据的场景
    handleProxyInstance(data?.billno);
  } else {
    unProxyInstance();
  }
  if (viewmodel) {
    viewmodel.un('refreshProxyInstance', handleProxyInstance);
    viewmodel.on('refreshProxyInstance', handleProxyInstance);
  }
  if (viewmodel) {
    const curbillNo = viewmodel.getParams?.()?.billNo;
    const curAuthkey = ttx.context.getDynamicAuthTokenByBillNo(curbillNo);
    ttx.utils._appendDynamicAuthToken(data?.billno, curAuthkey); // 将框架强制处理的无权（无权转有权）带入到下一个页面，前提是代办进入
    if (data.params && data.params.query) {
      data.params.query.sbillno = curbillNo;
      if (ttx.rest._ah?.currentBillIsOffline && ttx.rest._ah?.currentBillIsOffline?.()) {
        delete data.params.query.sbillno;
      }
    }
  }
}
//= =====================================================
// ttx.loader = {};
ttx.loader.getDomainKey = function (data) {
  return data.domainKey;
}
// 登录之后调用
ttx.loader.loadDomainResource = async function (domainKey, params) {
  if (!domainKey) return;
  const loadExtendList = [loadExtend(domainKey, null)]
  const feDomainKey = ttx.utils.getUrlParams()?.feDomainKey;
  const isDesign = ttx.__DIWORK_INTEGRATION_MODE__ === 'design';
  const loginDomainKey = isDesign ? (feDomainKey || domainKey) : domainKey;
  if (isDesign && feDomainKey && feDomainKey !== 'developplatform') {
    loadExtendList.push(loadExtend(feDomainKey, null)) // 低代码画布区需要加载当前领域的扩展资源
  }
  await Promise.all(loadExtendList);
  await Promise.all([getLoginUser(loginDomainKey, params, null)]);
  // ttx.lang && ttx.lang.extendsRender && ttx.lang.extendsRender(domainKey);
}
// 未登录调用，权加载前端资源
ttx.loader.loadResourceByDomain = async function (domainKey, params) {
  if (!domainKey) return;
  await loadExtend(domainKey, null)
}

ttx.loader.getExtendUrl = getExtendUrl;

ttx.loader.fromMenu = function (data, viewmodel, callback) {
  if (data && data.content) {
    data.params = ttx.utils.extend(true, {}, data);
    callback?.(data);
    return;
  }
  if (!data || !data.menuId) {
    // @ts-ignore
    ttx.console.error(Error.E00001, '[ttx.loader.fromMenu]: 函数ttx.loader.fromMenu的第一个参数data中未获取到有效的menuId')// @notranslate
    return
  }
  const userClick = data.userClick;
  let node;
  if (userClick) {
    node = data;
  } else {
    const portalTreeData = ttx.rest.AppContext.portalTreeData;
    if (!portalTreeData || portalTreeData.length == 0) {
      // @ts-ignore
      ttx.console.error(Error.E00007, '[ttx.loader.fromMenu]: ttx.loader.fromMenu方法需要参数portalTreeData,但上下文中未获取到有效值。') // @notranslate
      return
    }
    const loop = datas => datas.map((item) => {
      if (!node) {
        if (item.id == data.menuId) {
          node = Object.assign(data, item);
        } else {
          if (item.children) {
            loop(item.children)
          }
        }
      }
    })
    loop(portalTreeData);
    if (!node || node.length == 0) {
      // @ts-ignore
      ttx.console.error(Error.E00001, '[ttx.loader.fromMenu]: 函数ttx.loader.fromMenu的第一个参数data中的menuId错误,当前menuId为:' + data.menuId);// @notranslate
      return
    }
  }
  const returnData = { title: node.name, params: node };
  if (userClick)
    returnData.key = node.key || node.menuId;
  switch (node.viewType) {
    case 'meta': {
      let query = null;
      if (node.menuUrl) {
        const queryString = new ttx.utils.queryString(node.menuUrl);
        query = queryString.query;
      } else {
        query = {};
      }
      // 移动端
      if (ttx.rest.interMode === 'mobile') {
        const menuUrl = node.menuUrl && ttx.utils.stringToJSON(node.menuUrl);
        menuUrl && (query = ttx.utils.extend({}, query, menuUrl));
      }
      const params = ttx.utils.extend({}, node, { query: query });
      this.byBillNo({
        billtype: node.metaType,
        billno: node.metaKey,
        params: params
      }, viewmodel, callback && function (vm, view) {
        returnData.content = {
          vm: vm,
          metaData: view
        };
        callback(returnData);
      });
      break;
    }
    case 'platform':
      returnData.content = {
        type: node.viewType,
        url: node.menuUrl
      };
      callback?.(returnData);
      break;
    case 'ajax': {
      const diworkCode = data.params?.diworkCode || data.inputParams?.query?.serviceCode
      const proxy = ttx.rest.DynamicProxy.create({ getUrl: { url: node.menuUrl, method: 'GET', options: { diworkCode } } });
      proxy?.getUrl(function (err, result) {
        if (err) {
          ttx.utils.alert(err, 'error');
          return;
        }
        if (node.random)
          result = ttx.rest._appendUrl(result, { random: node.random });
        returnData.content = {
          type: 'iframe',
          url: ttx.utils.getPredicateValue(result)
        };
        callback?.(returnData);
      });
      break;
    }
    case 'external':
      returnData.content = {
        type: 'iframe',
        delay: node.delay,
        url: ttx.utils.getPredicateValue(node.menuUrl)
      };
      if (node.type === 'window') {
        const childWindow = window.open(returnData.content.url, returnData.key);
        window.addEventListener('message', (event) => {
          if (event.data.key === 'context') {
            const params = ttx.cache.get(event.data.random);
            childWindow.postMessage({ key: 'params', value: params }, event.origin);
          }
        }, false);
        return;
      }
      if (viewmodel) {
        viewmodel.communication({
          payload: returnData.content
        });
      } else {
        callback?.(returnData);
      }
      break;
  }
};
ttx.loader.asyncByBillNo = async function (data, viewmodel, callback) {
  return new Promise((resolve, reject) => {
    ttx.loader.byBillNo(data, viewmodel, callback, resolve)
  })
}
ttx.loader.initRefer = function (refCode, multiple, where, afterInit, afterOkClick, domainKey, referModel) {
  if (!ttx.extendConfig || !ttx.extendConfig.referViewModel) {
    // 依赖外部referviewModel文件
    ttx.models.getViewModel('referviewmodel');
  }

  const vm = new ttx.viewmodels.ReferViewModel({ params: { refCode: refCode, multiple: multiple, where: where, domainKey, referModel } });
  if (typeof afterInit === 'function')
    vm.on('afterInit', afterInit);
  if (typeof afterOkClick === 'function')
    vm.on('afterOkClick', afterOkClick);
  return vm;
};
/**
 * name: ViewModel名称，必填
 * path: ViewModel路径，选填，默认等于name
 * params: 携带参数，选填
 * parent: 隶属ParentViewModel，选填
 * events: 注册事件，选填
 */
ttx.loader.initMetaCommonViewModel = function (name, path, params, parent, events) {
  if (!name) return;
  if (!path)
    path = name;
  if (!parent) {
    if (name !== 'FilterViewModel' || !ttx.extendConfig || !ttx.extendConfig.filterViewModel) {
      // 依赖外部filterViewModel文件
      ttx.models.getViewModel('filterviewmodel', path);
    }
    return new ttx.viewmodels[name](params ? { params: params } : null);
  }
  let cacheName = name;
  const suffix = params && params.suffix;
  if (suffix)
    cacheName += suffix;
  let vm = parent.getCache(cacheName);
  if (vm) {
    if (ttx.utils.isArray(events)) {
      events.forEach(function (eventName) {
        vm.un(eventName);
        vm.on(eventName, function (data) {
          parent.execute(eventName, data);
        });
      });
    }
    ttx.utils.extend(vm.getParams(), params);
    if (typeof vm.initData === 'function')
      vm.initData();
    parent.setCache(cacheName, vm);

    parent.execute('afterInitCommonViewModel');
    return vm;
  }
  if (name !== 'FilterViewModel' || !ttx.extendConfig || !ttx.extendConfig.filterViewModel) {
    // 依赖外部filterViewModel文件
    ttx.models.getViewModel('filterviewmodel', path);
  }
  vm = new ttx.viewmodels[name](params ? { params: params } : null);
  vm.setCache('parentViewModel', parent);
  if (ttx.utils.isArray(events)) {
    events.forEach(function (eventName) {
      vm.on(eventName, function (data) {
        parent.execute(eventName, data);
      });
    });
  }
  parent.setCache(cacheName, vm);
  name == 'FilterViewModel' && parent.execute('afterInitCommonViewModel')
  return vm;
};

// ==================== Extend 注册 API（MDF cb.extend）====================
// 内部维护统一注册表，register 方法均为 merge 操作（同名领域追加而非覆盖）
ttx.extend._registry = ttx.extend._registry || {
  scripts: {},      // { [domainKey]: [scripts] }
  components: {},   // { [domainKey]: { [name]: component } }
  reducers: {},     // { [domainKey]: { [name]: reducer } }
  routes: {},       // { [domainKey]: [routes] }
  bizActions: {},   // { [domainKey]: { [name]: action } }
  envs: {},         // { [domainKey]: { [name]: value } }
  langs: {}         // { [domainKey]: pack }
};
// 自定义环境变量存储（框架变量直接挂 ttx.__VAR__）
ttx._envs = ttx._envs || {};

/**
 * 合并数组（去重追加）
 */
ttx.extend._mergeArray = function (target, items) {
  if (!ttx.utils.isArray(items)) return target || [];
  target = target || [];
  items.forEach(function (item) {
    if (target.indexOf(item) === -1) target.push(item);
  });
  return target;
};

/**
 * 合并对象（后者覆盖前者）
 */
ttx.extend._mergeObject = function (target, source) {
  if (!source || typeof source !== 'object') return target || {};
  target = target || {};
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  }
  return target;
};

/**
 * 注册扩展脚本（src/business）
 * @param {string} domainKey - 领域编码
 * @param {*} context - require.context 返回的上下文
 */
ttx.extend.registerScripts = function (domainKey, context) {
  if (!domainKey || !context) return;
  var reg = ttx.extend._registry;
  // 兼容 require.context 上下文与脚本数组两种形态
  var scripts = [];
  if (ttx.utils.isArray(context)) {
    scripts = context;
  } else if (typeof context === 'function' && context.keys) {
    // require.context 形态：遍历 keys 逐个 require
    context.keys().forEach(function (key) {
      try {
        scripts.push(context(key));
      } catch (e) {
        ttx.console.error('[ttx.extend.registerScripts]: 加载扩展脚本失败 ' + key, e);
      }
    });
  }
  reg.scripts[domainKey] = ttx.extend._mergeArray(reg.scripts[domainKey], scripts);
};

/**
 * 注册扩展组件
 * @param {string} domainKey - 领域编码
 * @param {object} components - 组件键值对 { [name]: component }
 */
ttx.extend.registerComponents = function (domainKey, components) {
  if (!domainKey || !components) return;
  var reg = ttx.extend._registry;
  reg.components[domainKey] = ttx.extend._mergeObject(reg.components[domainKey], components);
};

/**
 * 注册 reducer
 * @param {string} domainKey - 领域编码
 * @param {object} reducers - reducer 键值对
 */
ttx.extend.registerReducers = function (domainKey, reducers) {
  if (!domainKey || !reducers) return;
  var reg = ttx.extend._registry;
  reg.reducers[domainKey] = ttx.extend._mergeObject(reg.reducers[domainKey], reducers);
};

/**
 * 注册 router
 * @param {string} domainKey - 领域编码
 * @param {Array} routes - 路由数组
 */
ttx.extend.registerRoutes = function (domainKey, routes) {
  if (!domainKey || !ttx.utils.isArray(routes)) return;
  var reg = ttx.extend._registry;
  reg.routes[domainKey] = ttx.extend._mergeArray(reg.routes[domainKey], routes);
};

/**
 * 注册扩展 action
 * @param {string} domainKey - 领域编码
 * @param {object} actions - action 键值对
 */
ttx.extend.registerBizAction = function (domainKey, actions) {
  if (!domainKey || !actions) return;
  var reg = ttx.extend._registry;
  reg.bizActions[domainKey] = ttx.extend._mergeObject(reg.bizActions[domainKey], actions);
};

/**
 * 注册环境变量
 * - 框架变量名前后加 __（如 __PRINT_META__、__WORKFLOW_META__），直接挂到 ttx.__VAR__
 * - 自定义变量小驼峰，存到 ttx._envs，使用 viewmodel.getEnv('currentEnv') 读取
 * @param {string} domainKey - 领域编码
 * @param {object} env - 环境变量键值对
 */
ttx.extend.registerEnv = function (domainKey, env) {
  if (!domainKey || !env) return;
  var reg = ttx.extend._registry;
  reg.envs[domainKey] = ttx.extend._mergeObject(reg.envs[domainKey], env);
  for (var name in env) {
    if (Object.prototype.hasOwnProperty.call(env, name)) {
      var value = env[name];
      if (/^__.*__$/.test(name)) {
        // 框架变量直接挂到 ttx 上（如 ttx.__PRINT_META__）
        ttx[name] = value;
      } else {
        // 自定义变量存到 ttx._envs
        ttx._envs[name] = value;
      }
    }
  }
};

/**
 * 获取注册的环境变量
 * @param {string} name - 变量名
 * @returns {*} 变量值
 */
ttx.extend.getEnv = function (name) {
  if (!name) return undefined;
  // 框架变量从 ttx 读取
  if (/^__.*__$/.test(name)) {
    return ttx[name];
  }
  // 自定义变量从 ttx._envs 读取
  return ttx._envs ? ttx._envs[name] : undefined;
};

/**
 * 注册多语包
 * 若 ttx.lang 已有相关能力则协调，否则暂存到注册表
 * @param {string} domainKey - 领域编码
 * @param {object} pack - 多语包
 */
ttx.extend.registerLang = function (domainKey, pack) {
  if (!domainKey || !pack) return;
  var reg = ttx.extend._registry;
  reg.langs[domainKey] = ttx.extend._mergeObject(reg.langs[domainKey], pack);
  // 若 ttx.lang 提供注册能力则同步注册
  if (ttx.lang && typeof ttx.lang.register === 'function') {
    try {
      ttx.lang.register(domainKey, pack);
    } catch (e) {
      ttx.console.error('[ttx.extend.registerLang]: 注册多语包失败', e);
    }
  }
};
